import { Components, Theme } from "@mui/material";

export const muiButtonGroup: Components<Omit<Theme, "components">> = {
  MuiButtonGroup: {
    defaultProps: {
      disableElevation: true
    }
  }
};
